import {
  type AxiosRequestConfig,
  type DefaultQueryError,
  publicHttpClient,
} from '@ahm/api-wrappers-core';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';

interface SendOTPRequestBody {
  phone_number: string;
}

export interface SendOTPResponse {}

export const RequestOTPFn = async (
  body: SendOTPRequestBody,
  config: AxiosRequestConfig = {}
): Promise<SendOTPResponse> => {
  const response = await publicHttpClient.post<SendOTPResponse>(
    apiRoutes.ahafood.store.request_otp,
    body,
    {
      ...config,
    }
  );

  return response?.data;
};

export const useRequestOTP = (
  opts?: UseMutationOptions<
    SendOTPResponse,
    DefaultQueryError,
    SendOTPRequestBody
  >
) => {
  return useMutation<SendOTPResponse, DefaultQueryError, SendOTPRequestBody>({
    mutationFn: RequestOTPFn,
    ...opts,
  });
};
